import React from "react";
import { useGetAddOnsQuery, useGetAddOnPricesQuery } from "@/store/rest_api";
import { useAddOn } from "@/hooks/useAddOn";
import { AddOnType } from "@/model/interface/AddOn";
import { AddOnUpsell } from "@/components/addon/AddOnUpsell";

interface AddOnProtectedRouteProps {
  addOns: AddOnType | AddOnType[];
  children: React.ReactNode;
  title: string;
  description: string;
  price?: string;
}

export function AddOnProtectedRoute({ addOns, children, title, description, price }: AddOnProtectedRouteProps) {
  const has = useAddOn(addOns);
  const { isLoading } = useGetAddOnsQuery();
  const { data: prices } = useGetAddOnPricesQuery();

  if (isLoading) {
    return null;
  }
  if (!has) {
    const types = Array.isArray(addOns) ? addOns : [addOns];
    const cents = (prices ?? [])
      .filter((entry) => types.includes(entry.addOnType))
      .map((entry) => entry.effectiveMonthlyCostCents);
    const cheapest = cents.length > 0 ? Math.min(...cents) : undefined;
    const value = cheapest != null ? cheapest / 100 : undefined;
    const effectivePrice =
      value != null ? `From $${value % 1 === 0 ? value : value.toFixed(2)}/mo` : price;
    return <AddOnUpsell title={title} description={description} price={effectivePrice} />;
  }
  return <>{children}</>;
}
